export class FeatureItem {
  name: string;
  iconUrl: string;
  title?: string;
  alt: string;
  description: string;
  _$visited?: any;

  constructor() {
    this.alt = 'Storage Facility Features';
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/feature-item.ts